import { render, staticRenderFns } from "./flag-component.vue?vue&type=template&id=2af1255c&scoped=true&"
import script from "./flag-component.vue?vue&type=script&lang=js&"
export * from "./flag-component.vue?vue&type=script&lang=js&"
import style0 from "./flag-component.vue?vue&type=style&index=0&id=2af1255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1255c",
  null
  
)

export default component.exports